import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import _ from "lodash";
import { showNavbar } from "../../store/modules/appStateSlice";
import SecondaryMenu from "../shared/SecondaryMenu";
import BaseBlock from "./BaseBlock";
import ErrorTryAgain from "../shared/ErrorTryAgain/ErrorTryAgain";
import { Button, CircularProgress, FormHelperText, Grid, MenuItem, Select } from "@material-ui/core";
import { BaseType, VehicleType } from "./types";
import api from "../../store/api";
import { Controller, useForm } from "react-hook-form";
import { getData, getRoles, persistName, setData } from "../Schedule/helpers/transferScheduleHelpers";
import { RootState } from "../../store/rootReducer";
import { consts } from "../../common/consts";

interface CustomersWithFleet {
  name: any;
  customerId: any;
  selected: boolean|undefined;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "stretch",
    flexGrow: 1,
  },
  leftMenu: {
    alignSelf: "stretch",
    display: "flex",
  },
  main: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 40,

    "& h1": {
      fontSize: "36px",
      fontWeight: 900,
      margin: 0,
      padding: 0,
    },
  },
  actionButtons: {
    display: "flex",
  },
  trackBtn: {
    fontSize: 14,
  },
  addVehicleBtn: {
    marginLeft: 15,
    fontSize: 14,
  },
  content: {
    display: "flex",
    flex: "1",
    position: "relative",
    padding: "0 40px 40px",
  },
  loading: {
    width: "calc(100% - 80px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    position: "absolute",
    height: "100%",
  },
  error: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  baseList: {
    width: "100%",
    columnCount: 2,
    columnGap: "20px",
    breakInside: "avoid",
  },
  gridContent: {
    paddingRight: "10px",
  },
  gridContentContainer: {
    display: "flex",
    position: "relative",
    padding: "0 40px 40px",
  },
}));

const VehiclesPage = (): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();
  const style = useStyles();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [bases, setBases] = useState<BaseType[]>([]);
  const [vehicles, setVehicles] = useState<VehicleType[]>([]);
  const [customersWithFleet, setcustomersWithFleet] = useState<CustomersWithFleet[]>([]);
  const [customerId, setCustomerId] = useState<string|null|undefined>(null);
  const [selectedValue, setSelectedValue] = useState<any|null>(null);
  const [SMACustomerId, setSMACustomerId] = useState<any|null>(null);
  const [SMACustomerName, setSMACustomerName] = useState<any|null>(consts.Customers.SMA);
  const [isSMACustomer, setIsSMACustomer] = useState(false);
  const { customer } = useParams<{ customer: string }>();

  const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError, trigger } = useForm();
  
  const { authStore } = useSelector((state: RootState) => state);
  const [isAdmin, setIsAdmin] = React.useState<any>(authStore?.data?.IsAdmin || authStore.data?.role.split(",").includes(consts.Permissions.SMAAdminManageVehicles));

  useEffect(() => {
      dispatch(showNavbar(true));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setIsError(false);
    if (isAdmin)
    {
      api
        .getFleetOfCustomerList()
        .then((res) => {
          let _res=res.data.model;
          let _selectedValue:any=null;
          let _customerList:CustomersWithFleet[]=[];
          for (let item = 0; item < _res.length; item++) {
            let customerBody: CustomersWithFleet = {
              name: _res[item].text,
              customerId: _res[item].value,
              selected: _res[item].selected
            };
            if (_res[item].selected){
              _selectedValue=customerBody.customerId;
            }
            if (customerBody.name==SMACustomerName)
              setSMACustomerId(customerBody.customerId);
            _customerList.push(customerBody);
          }
          setcustomersWithFleet(_customerList);
          if (customer==null||customer==undefined||customer=="null")
            setSelectedValue(_selectedValue);
          else
            setSelectedValue(customer);
        })
        .catch((error) => {
          setIsError(true);
          setIsLoading(false);
        });
    }
    else
    {
      if(authStore.data?.IsCustomer)
      {
        setCustomerId(authStore.data.CustomerId)
      }
      else
      {
        setCustomerId(authStore.data?.location);
      }      
        api
          .getCustomerVehiclesBases(authStore.data?.location)
          .then((res) => {
            setBases(_.get(res, "data.model.bases") || []);
            setVehicles(_.get(res, "data.model.vehicles") || []);
            setIsLoading(false);
          })
          .catch((error) => {
            setIsError(true);
            setIsLoading(false);
          });
    }
  }, []);

  useEffect(() => {
    if (selectedValue!=null)
    {
      if (selectedValue===SMACustomerId)
        setIsSMACustomer(true);
      else
        setIsSMACustomer(false);
      if (isAdmin)
      {
        setCustomerId(selectedValue);
        setValue("customersWithFleet",selectedValue);
        api
              .getVehiclesBases(selectedValue)
              .then((res) => {
                setBases(_.get(res, "data.model.bases") || []);
                setVehicles(_.get(res, "data.model.vehicles") || []);
                setIsLoading(false);
              })
              .catch((error) => {
                setIsError(true);
                setIsLoading(false);
              }); 
        }
    }
  }, [selectedValue]);

  const addVehicleClick = (customerId: string|null|undefined) => {
    if (isAdmin)
      history.push({
        pathname: `/settings/vehicles/add/${customerId}`,
      });
    else
      history.push({
        pathname: `/managevehicles/add/${customerId}`,
      });
  };

  const trackFleetClick = () => {
    history.push({
      pathname: "/trackfleet",
    });
  };

  const dragDropAction = async ({ vehicle, newBaseId }: { vehicle: VehicleType; newBaseId: string }) => {
    setIsLoading(true);
    const payload = {
      ...vehicle,
      baseId: newBaseId,
    };
    await api
      .updateVehicle("", payload)
      .then((res) => {
        if (res.hasError) {
          throw new Error(res.message);
        }
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);
        return;
      });

    setVehicles((vehicles) =>
      vehicles.map((v) => {
        if (v.vehicleId === vehicle.vehicleId) {
          return {
            ...v,
            baseId: newBaseId,
          };
        }
        return v;
      })
    );
    setIsLoading(false);
  };

  const onChangeCustomersWithFleet = async (location: any) => {
    setCustomerId(location);
    if (location===SMACustomerId)
        setIsSMACustomer(true);
      else
        setIsSMACustomer(false);
    setIsLoading(true);
    setIsError(false);
    let _loc=null;
    if (location!="SMA")
      _loc=location;
    api
      .getVehiclesBases(_loc)
      .then((res) => {
        setBases(_.get(res, "data.model.bases") || []);
        setVehicles(_.get(res, "data.model.vehicles") || []);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);
      });
  }

  return (
    <div className={style.root}>
      {isAdmin ?(<div className={style.leftMenu}>
        <SecondaryMenu selectedmenu={"Vehicles"} />
      </div>):""}
      <div className={style.main}>
        <div className={style.heading}>
          <h1>Vehicles</h1>
          <div className={style.actionButtons}>
            {isAdmin && isSMACustomer ?(<Button className={style.trackBtn} variant="outlined" color="primary" onClick={trackFleetClick}>
              Track Fleet
            </Button>):""}
            <Button className={style.addVehicleBtn} variant="contained" color="primary" onClick={() =>addVehicleClick(customerId)}>
              Add Vehicle
            </Button>
          </div>
        </div>
        {isAdmin ?(<div className={style.gridContentContainer}>
          <Grid item xs={4} className={style.gridContent}>
            <Controller
              name='customersWithFleet'
              defaultValue=''
              control={control}
              render={({ onChange, onBlur, value, name }) => (
                  <React.Fragment>
                      <Select
                          onChange={e => {
                              // onChangepatientOfLocation(e)
                              onChange(e)
                              onChangeCustomersWithFleet(e.target.value)
                          }}
                          value={value}
                          name={name}
                          //IconComponent={KeyboardArrowDownIcon}
                          fullWidth={true}
                          //classes={{icon:classes.dropdownIcon}}
                          variant="outlined">
                          {
                              customersWithFleet.filter(item => item).map(item => <MenuItem selected={item.selected} key={item.customerId} defaultValue={item.customerId} value={item.customerId}>{item.name}</MenuItem >)
                          }
                          
                      </Select>
                  </React.Fragment>
              )}
              rules={{
                  validate: (value) => {
                      if (value === null || value === '') {
                          return "Location is required"
                      }
                  }
              }}
            />
          </Grid>
        </div>):""}
        {!isLoading && vehicles.length === 0 ? <div style={{ display: "flex", justifyContent: "center", fontSize: "20px", marginBottom:"40px" }}>No vehicles found</div> : ""}
        <div className={style.content}>
          {isLoading && (
            <div className={style.loading}>
              <CircularProgress />
            </div>
          )}
          {isError && (
            <div className={style.error}>
              <ErrorTryAgain noBackground={true} />
            </div>
          )}
          {!isError && (
            <div className={style.baseList}>
              {bases.map((b) => {
                return <BaseBlock key={b.baseId} base={b} vehicles={vehicles.filter((v) => v.baseId === b.baseId)} dragDropAction={dragDropAction} />;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehiclesPage;
